document.addEventListener('AppleIDSignInOnSuccess', (event) => {
    console.log('AppleIDSignInOnSuccess:')
    console.log(event.detail.authorization);
});

document.addEventListener('AppleIDSignInOnFailure', (event) => {
    window.onAppleIDSignIDFailed && window.onAppleIDSignIDFailed();
    console.log(event.detail);
});

const appleIdInit = (sid) => {
    window.AppleID && AppleID.auth.init({
        clientId: 'webstorebingo',
        scope: 'name email',
        redirectURI: `https://store.drbingo.com`,
        state: "signintype=apple",
        usePopup: true
    });
}

const appleIdSignIn = async () => {
    return await AppleID.auth.signIn()
}

export default {
    appleIdInit: appleIdInit,
    appleIdSignIn: appleIdSignIn
}



// WEBPACK FOOTER //
// ./src/network/apple.js